import { useEffect, useState } from "react";
import { ExternalLink, Gift } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";
import { toast, Toaster } from "sonner";
import { Reveal, Floral, GoldDivider } from "../components/Decor";
import { GIFTS_INTRO } from "../constants/site";

export default function ListaPresentes() {
  const [gifts, setGifts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/gifts")
      .then(({ data }) => setGifts(data.gifts || []))
      .catch((e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="relative overflow-hidden pt-28" data-testid="page-presentes">
      <Floral variant="top" className="absolute -left-20 -top-4 w-72 opacity-80" />
      <header className="relative mx-auto max-w-3xl px-5 text-center">
        <p className="eyebrow">Presentes</p>
        <h1 className="mt-4 font-script text-6xl text-ink sm:text-7xl">Lista de Presentes</h1>
        <GoldDivider className="mt-8" />
        <p className="mx-auto mt-8 max-w-2xl font-serif text-lg italic leading-relaxed text-ink/80 sm:text-xl">{GIFTS_INTRO}</p>
      </header>

      <section className="mx-auto max-w-6xl px-5 py-14" data-testid="gifts-grid">
        {loading ? (
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="h-80 animate-pulse border border-gold-border bg-white/60" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {gifts.map((g, i) => (
              <Reveal key={g.id} delay={0.04 * (i % 3)}>
                <article className="paper-card group flex h-full flex-col" data-testid={`gift-card-${i}`}>
                  <div className="overflow-hidden bg-white">
                    <img
                      src={g.image}
                      alt={g.name}
                      loading="lazy"
                      className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                    />
                  </div>
                  <div className="flex flex-1 flex-col p-6 text-left">
                    <h3 className="flex-1 font-serif text-xl leading-snug text-ink">{g.name}</h3>
                    <p className="mt-3 font-serif text-2xl text-gold-deep">{g.price}</p>
                    <a
                      href={g.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`gift-card-donate-btn-${i}`}
                      className="btn-gold mt-5 w-full"
                    >
                      <Gift size={13} /> Presentear
                    </a>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        )}
        <p className="mt-10 flex items-center justify-center gap-2 text-center font-sans text-xs font-light text-muted" data-testid="gifts-note">
          <ExternalLink size={12} />
          Você será direcionado à InfinitePay para presentear os noivos com segurança.
        </p>
      </section>
      <Toaster position="top-center" richColors />
    </div>
  );
}
